{
  "login": {
    "title": "Entrar",
    "subtitle": "Bem-vindo de volta ao Sigma08",
    "email": "Endereço de Email",
    "password": "Senha",
    "rememberMe": "Lembrar de mim",
    "forgotPassword": "Esqueceu a senha?",
    "submit": "Entrar",
    "noAccount": "Não tem uma conta?",
    "signUp": "Cadastre-se",
    "or": "Ou continue com",
    "google": "Google",
    "microsoft": "Microsoft"
  },
  "signup": {
    "title": "Criar Conta",
    "subtitle": "Comece sua jornada de aprendizado",
    "firstName": "Nome",
    "lastName": "Sobrenome",
    "email": "Endereço de Email",
    "password": "Senha",
    "confirmPassword": "Confirmar Senha",
    "role": "Eu sou",
    "roles": {
      "teacher": "Professor",
      "parent": "Pai/Mãe",
      "student": "Aluno"
    },
    "terms": "Concordo com os Termos de Serviço e Política de Privacidade",
    "submit": "Criar Conta",
    "hasAccount": "Já tem uma conta?",
    "signIn": "Entrar"
  },
  "forgotPassword": {
    "title": "Redefinir Senha",
    "subtitle": "Digite seu email para receber instruções",
    "email": "Endereço de Email",
    "submit": "Enviar Link",
    "backToLogin": "Voltar ao login",
    "success": "Verifique seu email para instruções"
  },
  "resetPassword": {
    "title": "Definir Nova Senha",
    "subtitle": "Escolha uma senha forte para sua conta",
    "password": "Nova Senha",
    "confirmPassword": "Confirmar Senha",
    "submit": "Redefinir Senha",
    "success": "Senha redefinida com sucesso"
  },
  "logout": {
    "title": "Sair",
    "message": "Tem certeza que deseja sair?",
    "confirm": "Sair",
    "cancel": "Cancelar"
  }
}
